import { dangerColor, successColor, warningColor } from '@/scss/variables';
import { KksState } from 'types';

export const KKSStatesColorTags: Record<string, string> = {
  [KksState.DMS_CONFIRMED]: `background-color: color-mix(in srgb, ${warningColor}, transparent 84%); color: ${warningColor}`,
  [KksState.NON_CONFORMING]: `background-color: color-mix(in srgb, ${dangerColor}, transparent 84%); color: ${dangerColor}`,
  [KksState.PLANNED]: `background-color: color-mix(in srgb, ${warningColor}, transparent 84%); color: ${warningColor}`,
  [KksState.DMS_PROPOSED]: `background-color: color-mix(in srgb, ${warningColor}, transparent 84%); color: ${warningColor}`,
  [KksState.SAP_PM]: `background-color: color-mix(in srgb, ${successColor}, transparent 84%); color: ${successColor}`,
  [KksState.UNDEFINED]: `background-color: color-mix(in srgb, ${dangerColor}, transparent 84%); color: ${dangerColor}`,
};
